export class Graphics {
	public solicitations: Graphic = new Graphic()
	public evaluations: Graphic = new Graphic()
	public riskClasses: Graphic = new Graphic()
	public managements: Graphic = new Graphic()
	public managementsClasses: Graphic = new Graphic()
	public dapTreeInventory: Graphic = new Graphic()
	public speciesTreeInventaried: Graphic = new Graphic()
	public heightTreeInventory: Graphic = new Graphic()
	public originSpeciesTreeInventaried: Graphic = new Graphic()
	public totalTreeCadastredInventory: number = 0

	// Planting opportunities
	public plantingOpportunities: Graphic = new Graphic()
	public totalInventoryFromPlantingOpportunities: number = 0

	public plantingSpeciesTreeInventaried = new Graphic()

	public plantingOriginSpeciesTreeInventaried = new Graphic()
}

export class Graphic {
	public total: number
	public data: Array<Data>

	constructor() {
		this.total = 0
		this.data = new Array(new Data())
	}
}

export class Data {
	public title: string
	public order: number
	public color: string
	public value: number
	public percent: number

	constructor() {
		this.title = ''
		this.order = 0
		this.color = ''
		this.value = 0
		this.percent = 0
	}
}
